import React from 'react';
import { Pagination as MuiPagination, Stack } from '@mui/material';
import default_theme from 'assets/themes/themes';

const Pagination = ({ count, page, onPageChange }) => {
  return (
    <Stack spacing={2} alignItems="center" style={{ marginTop: '40px', marginBottom: '60px' }}>
      <MuiPagination
        count={count} 
        page={page}
        onChange={(event, value) => onPageChange(event, value)}
        size="large"
        showFirstButton
        showLastButton
        sx={{
          '& .MuiPaginationItem-root': { 
            color: default_theme.palette.font.gray,
            fontSize: '1.1rem',
            minWidth: '40px',
            height: '40px'
          },
          '& .Mui-selected': {
            backgroundColor: default_theme.palette.primary.green,
            color: default_theme.palette.font.gray
          }
        }}
      />
    </Stack>
  );
};

export default Pagination;